import React, { useEffect, useState } from "react";
import { ErrorMessage, Field, Formik } from "formik";
import TextError from "./TextError";
import { characters, format, pinFormat, postCode, posportVisa, customEmail, yearRegex, numberRegex, namePattern } from "../../config/regex/regexPattern";
import { valudatesetformstatus } from "../../pages/onboarding/Onboarding";


const SplitInput = (props: any) => {
    
    const { name, label, type, className, allData, formik, completedPage, doTfnFormValidation, clearChilInput, setTfnFieldValue,  maxlength, ...rest } = props;
    const splitLength = Array(allData?.boxCount).fill(null);
    const currentYear = new Date().getFullYear();
    const isBetween = (num: number, min: number, max: number): boolean => {
        return num >= min && num <= max;
    };

    const finalUserInput = (splitLength : any) => {
        const values: any[] = [];
        splitLength.forEach((_: any, index: number) => {
            const element = document.getElementById(`${name}-${index}`);
            const fieldInputValue : any = element ? (element as HTMLInputElement).value : "";
            if(fieldInputValue !== ""){
                values.push(fieldInputValue);
            }
        });
        return values.join("");
    };
    useEffect(() => {
        let index = 0;
        if(clearChilInput){
            splitLength.forEach((_: any, index: number) => {
                const currentInput = document.getElementById(`${name}-${index}`) as HTMLInputElement;
                if(formik && currentInput){
                    formik.setFieldValue(`${name}-${index}`, "");
                }
            });
        }
    }, []);


    const fieldValidation = (fieldValue: any) => {
        let error: any; 

        if (allData.validate) {
            if (allData.subtype === "text" || allData.subtype === "email" || allData.subtype === "number") {
                const finalUserValue = finalUserInput(splitLength);

                if(doTfnFormValidation !== "" && doTfnFormValidation !== undefined && doTfnFormValidation !== null){
                    const isDependentField = allData.name === doTfnFormValidation || allData.name?.startsWith(`${doTfnFormValidation}-`);
                    if(isDependentField){
                        return error;
                    }
                }
               
                allData?.validations.forEach((element: any) => {
                    if (allData.type === "text" || allData.type === "split-input") {
                        if (element.type === "required" && valudatesetformstatus !== "draft") {
                            if(finalUserValue.length < 1){
                                error = element.params[0];
                            }

                            if(allData.tfnLabel === "DOB_yyyy"){
                                const year = parseInt(finalUserValue);
                                if (!yearRegex.test(finalUserValue) || year < 1900 || year > currentYear) {
                                    error = element.params[0];
                                }
                            }

                            if (["TFN 1", "TFN 2", "TFN 3"].includes(allData.tfnLabel) && finalUserValue.length > 0) {
                                if (finalUserValue.length !== 3 && valudatesetformstatus !== "draft") {
                                    error = `Fill all three ${allData.tfnLabel}`;
                                }
                            }

                            if(allData?.checkSplitLength && finalUserValue.length > 0){
                                if (finalUserValue.length !== allData?.boxCount && valudatesetformstatus !== "draft") {
                                    error = `Fill all the ${allData.tfnLabel}`;
                                }
                            }
                            
                        } else if (element.type === "pin_format") {
                            if(finalUserValue.length < 1 && valudatesetformstatus !== "draft"){
                                error = allData?.validations[0]?.params[0];
                            } else if (finalUserValue.length > 1 && !pinFormat.test(finalUserValue)) {
                                error = element.params[0];
                            }
                        } else if (element.type === "postcode") {
                            if(finalUserValue.length < 1 && valudatesetformstatus !== "draft"){
                                error = allData?.validations[0]?.params[0];
                            } else if (!postCode.test(finalUserValue) && finalUserValue.length > 1) {
                                error = element.params[0];
                            }
                        }
                        else if (element.type === "passport_number") {
                            if (!posportVisa.test(finalUserValue?.trim())) {
                                error = element.params[0];
                            }
                        } else if (element.type === "characters" && finalUserValue?.length > 0) {
                            if (allData.pdfLabel !== "Othername" && valudatesetformstatus !== "draft") {
                                if (finalUserValue.length < 1 || !namePattern.test(finalUserValue)) {
                                    error = element.params[0];
                                }
                            } else if (finalUserValue.length >= 1 && !namePattern.test(finalUserValue) && allData.pdfLabel === "Othername") {
                                error = element.params[0];
                            }
                        } else if (element.type === "min-max") {
                            if(isNaN(Number(finalUserValue))){
                                error = element.params[0];
                            }else if(finalUserValue !== ""){
                                if(!isBetween(parseInt(finalUserValue),element?.min_value,element?.max_value)){
                                    error = element.params[0];
                                }
                            }
                        } else if (element.type === "number") {
                             // Check if the input is a number
                             if(finalUserValue.length >= 1){
                                if (isNaN(Number(finalUserValue))) { 
                                    error = element.params[0];
                                }
                            }

                            if(allData.tfnLabel === "DOB_yyyy" && finalUserValue?.length > 0){
                                const year = parseInt(finalUserValue);
                                if (!yearRegex.test(finalUserValue) || year < 1900 || year > currentYear) {
                                    error = element.params[0];
                                }
                            }
                        }else if (element.type === "email") {
                            if (element.type === "required" && !finalUserValue && valudatesetformstatus !== "draft") {
                                error = element.params[0];
                            } else if (!finalUserValue && valudatesetformstatus === "draft" && completedPage) {
                                if (element.type === "required") {
                                    error = element.params[0];
                                }
                            } else if (element.type === "email" && finalUserValue) {
                                if (!customEmail.test(finalUserValue)) {
                                    error = element.params[0];
                                }
                            }
                        }
                    }
                });

            }
        }
        return error;
    };


    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>, index: number) => {
        if (e.key === "Backspace" && !e.currentTarget.value && index > 0) {
            const currentInput = document.getElementById(`${name}-${index}`);
            if (currentInput && (currentInput as HTMLInputElement).value === "") {
                const prevInput = document.getElementById(`${name}-${index - 1}`);
                prevInput?.focus();
            } else if (currentInput) {
                (currentInput as HTMLInputElement).value = "";
            }
        }
    };

    const getNextFieldName = (name: string): string => {
        const parts = name.split("-");
        if (parts.length < 4) {
            throw new Error("Invalid field name format");
        }
        const currentIndex = parseInt(parts[2], 10);
        const nextIndex = currentIndex + 1;
        parts[2] = nextIndex.toString();
        parts[3] = "0"; // Reset the last part to 0
        return parts.join("-");
    };

    const clearRadioInputByName = (name: string): void => {
        if(name === "" || name === undefined || name === null){
            return;
        }
        const radioButtons = document.getElementsByName(name) as NodeListOf<HTMLInputElement>;
        radioButtons.forEach((radio) => {
            radio.checked = false; // Uncheck each radio button
        });

        // Reset the Formik state for the radio group
        if (formik) {
            formik.setFieldValue(name, ""); // Clear the value in Formik
        }
    };


    const moveToNextSplitInput = (e: React.ChangeEvent<HTMLInputElement>, index: number, allData : any) => {
        let { value } = e.currentTarget;
        value = value ? value.toUpperCase() : value;
        if(value?.length >= 1 && allData?.pensionFieldName !== ""){
            clearRadioInputByName(allData?.pensionFieldName);
        }
        
        const moveToNextFields = ["DOB MM", "DOB DD", "TFN 1", "TFN 2"];
        if (value && index <= splitLength.length - 1) {
            const currentInput = document.getElementById(`${name}-${index}`) as HTMLInputElement;
            const nextInput = document.getElementById(`${name}-${index + 1}`) as HTMLInputElement;

            if (currentInput) {
                currentInput.value = value.toUpperCase();
            }
            if (nextInput) {
                nextInput.focus();
                nextInput.select();
            }else if(allData?.moveToNext){ // Only for TFN and date of birth we need to move to next field.
                let nextFieldId = getNextFieldName(`${name}-${index}`);
                const nextBlockInput = document.getElementById(nextFieldId) as HTMLInputElement;
                nextBlockInput?.focus();
                nextBlockInput?.select();
            }
        }
    };

    

    

    return (
        <>
            <div className="class-name split-input-field">
                {splitLength.map((_: any, index: number) => (
                    <div key={`${name}-${index}`}>
                        <Field type={allData?.subtype ? allData?.subtype : "text"} key={`${name}-${index}`} name={`${name}-${index}`} disabled={allData?.disabled} id={`${name}-${index}`} validate={fieldValidation}
                        onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => handleKeyDown(e, index)}
                        placeholder={(() => {
                            if (allData.pdfLabel === "DOB MM") { return "M"; }
                            if (allData.pdfLabel === "DOB DD") { return "D"; }
                            if (allData.pdfLabel === "DOB YYYY") { return "Y"; }
                            return "";
                        })()}
                        onInput={(e: React.ChangeEvent<HTMLInputElement>) => {
                            const input = e.currentTarget;
                            if (input.value.length > 1) {
                                input.value = input.value.slice(0, 1); // Allow only the first character
                            }
                            moveToNextSplitInput(e, index, allData);
                        }}
                        className={className}   maxLength={1} {...rest} />
                        
                    </div>
                ))}
            </div>
            <ErrorMessage name={`${name}-0`} component={TextError} />
        </>
    );
};

export default SplitInput;
